<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      :visible.sync="modalVisible"
      :mask="false"
      notFooterPadding
      :contentStyle="{'height': '100%'}"
      @open="modalOpen"
      @cancel="cancel"
      @confirm="confirm">
    <template #header>
      <span>添加产品</span>
    </template>
    <template #content>
      <app-base-main
          :table-shadow="false"
          :no-padding="true"
          parentTable
          >
        <template #filter-group>
          <app-filter-group
              :reset="false"
              @query="$gjNoticeQuery">
            <gj-select-input
                v-model="filter.keyword"
                :options="[
                  {id: 'sku', text: 'SKU'},
                  {id: 'name', text: '产品名称'},
                ]"
                :width="['100px', '150px']"
            ></gj-select-input>
            <gj-select
                v-model="filter.type"
                :options="ProductEnum.typeOption"
                placeholder="产品类型"
            ></gj-select>
            <gj-brand-select
                v-model="filter.brandId"
                placeholder="品牌"
            ></gj-brand-select>
            <gj-category-select
                v-model="filter.categoryIds"
                width="170px"
                multiple
            ></gj-category-select>
          </app-filter-group>
        </template>
        <template #table>
          <gj-table
              ref="gjTable"
              adaptParent
              :index="false"
              name="printProductLabel"
              :loading="loading"
              :data="tableData"
              :columns="columns"
              :offset-height="54"
              selection
              :pagination="pagination"
              @sort-change="$gjSortChange"
              @page-change="$gjNoticeQuery">
          </gj-table>
        </template>
      </app-base-main>
    </template>
  </gj-modal>
</template>

<script>
  import {modalMixIn, queryMixin, selectionMixin} from "../../../../../../minxins";
  import {ProductEnum} from "../../../../../../utils/options";
  import {defaultVal, isMeaningful} from "../../../../../../utils/common";
  import {getChildProductPage, getProductPage} from "../../../../../../api/product";

  export default {
    name: "app-add-product-modal",
    mixins: [modalMixIn, queryMixin, selectionMixin],
    props: {
      hideSkuList: {
        type: Array,
        default: () => []
      }
    },
    created() {
    
    },
    data() {
      return {
        tableData: [],
        columns: [
          {id: 'picture', header: '图片', field: 'picture:smallImageUrl', width: '50px'},
          {id: 'sku', header: 'SKU', field: 'sku', minWidth: '120px'},
          {id: 'name', header: '产品名称', field: 'name', minWidth: '200px'},
          {id: 'productType', header: '产品类型', field: 'option:productType', options: ProductEnum.typeOption, width: '80px'},
          {id: 'categoryName', header: '品类', field: 'categoryName', minWidth: '100px'},
          {id: 'brandName', header: '品牌', field: 'brandName', minWidth: '100px'},
        ],
        filter: {
          keyword: {
            key: 'sku',
            value: null
          },
          type: null,
          brandId: null,
          categoryIds: [],
        },
        ProductEnum: ProductEnum
      }
    },
    methods: {
      $gjQuery() {
        // 构造查询参数
        const params = {
          model: {
            productType: defaultVal(this.filter.type, null),
            brandIds: isMeaningful(this.filter.brandId) ? [this.filter.brandId] : null,
            categoryIds: isMeaningful(this.filter.categoryIds) ? this.filter.categoryIds : null,
            hideSkuList: this.hideSkuList
          },
          ...this.queryPagination,
          ...this.querySort
        };
        params.model[this.filter.keyword.key] = this.filter.keyword.value;
        // 查询
        this.loading = true;
        getChildProductPage(params)
          .then((data) => {
            if (isMeaningful(data)) {
              this.tableData = data.records;
              this.pagination = this.getPagination(data);
            } else {
              this.tableData = [];
            }
          })
          .complete(() => {
            this.loading = false;
          });
      },
      confirm() {
        if (this.selectedRows.length === 0) {
          this.$gjMessage.error('请勾选产品');
          return;
        }
        this.$emit('select', this.selectedRows);
        this.$gjDestroy();
      }
    }
  }
</script>

<style scoped>
  .add-product-btn {
    margin: 5px 0 10px;
  }
</style>
